import axios from 'axios'
import { useStore } from '@/stores/index.js'

function generateNonce(length = 13) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }
  return result
}


export function createAxiosInstance(options = {}) {


  const {
    baseURL = import.meta.env.VITE_APP_API_BASE_URL,
    timeout = 30000,
    getAuth,
    showLoading,
    hideLoading,
    showError,
    handle403,
  } = options;

  const instance = axios.create({
    baseURL,
    timeout,
    headers: { "Content-Type": "application/json" },
  });
  /**
   * 请求拦截
   */
  instance.interceptors.request.use(
    (config) => {

      const store = useStore()
      const { sign, uid } = store.userInfo || {}

      //所有请求都带
      const commonParams = {
        nonce: generateNonce(),
        timestamp: Date.now(),
      }

      // console.error(sign);
      // console.error(uid);

      //只有“需要登录态”的请求才带
      if (!config.noAuth && sign && uid) {
        // commonParams.sign = sign
        // commonParams.userid = uid
      }

      // 开启 loading
      showLoading && showLoading()

      // 获取基础参数（比如 P_PARAMS）
      const baseParams = getAuth ? getAuth() : {}

      // 根据请求类型合并参数
      if (config.method === 'post') {
        config.data = {
          ...baseParams,
          ...commonParams,
          ...(config.data || {}),
        }

      }

      return config
    },
    (error) => {
      hideLoading && hideLoading()
      return Promise.reject(error)
    }
  )

  /**
   * 响应拦截
   */
  instance.interceptors.response.use(
    (response) => {
      hideLoading && hideLoading()
      console.log(response.data);
      const res = response.data


      if (res.state === "200") {
        return res
      } else if (res.state === "403") {
        handle403 && handle403(res.msg || 'Login expired or no permission')
        return Promise.reject(res)
      }
      else if (res.state === "404") {
        showError && showError(`${response.request.responseURL} 404 Not Found`)
        return Promise.reject(res)
      }
      else if (res.state === "500") {
        handle403 && handle403(res.msg)
        return Promise.reject(res)
      }
      else {
        showError && showError(`${response.request.responseURL} RequestError`)
        return Promise.reject(res)
      }
    },
    (error) => {
      hideLoading && hideLoading()

      // 网络错误 / HTTP 错误
      if (error.response) {
        const status = error.response.status

        if (status === 403) {
          handle403 && handle403('Login expired or no permission')
        }
        else if (status === 404) {
          showError && showError(`${error.response.request.responseURL} 404 Not Found`)
        }
        else if (status === 500) {
          showError && showError(`${error.response.request.responseURL} 500 Internal Server Error`)
        }
        else {
          showError && showError(`RequestError (${status})`)
        }
      } else {
        showError && showError('RequestError Please try again later')
      }

      return Promise.reject(error)
    }
  )

  return instance
}
